import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Icon } from '../../icon/Icon';
import styled, { css } from 'styled-components';
import { mainTheme } from '@plecto/ui';

const S = {};

S.PathButton = styled.span`
	color: ${mainTheme.text.tertiary};

	${props => props.$enabled ? css`
		cursor: pointer;

		&:hover {
			text-decoration: underline;
			color: ${mainTheme.text.primary};
		}
	` : ''}
`;

S.Arrow = styled(Icon)`
	margin: 0 5px;
	color: ${mainTheme.text.tertiary};
`;

export default function Breadcrumb({ value, label, goToLevel, isLast }) {
	const onClick = useCallback(() => goToLevel(value), [goToLevel, value]);
	return <>
		<S.PathButton className={classNames('multi-level-dropdown-breadcrumbs-path-btn', {
			'multi-level-dropdown-breadcrumbs-path-btn-enabled': !isLast
		})} onClick={onClick} $enabled={!isLast}>{label}</S.PathButton>
		{!isLast && <S.Arrow className="multi-level-dropdown-breadcrumbs-path-arrow" name="chevron-right" />}
	</>;
}
